module.exports = (Promise.resolve(__parcel__require__("./" + "RistrettoBroadcasting.2921d520.6f24568d.js"))).then(() => parcelRequire('6wFPA'));